import { isProduction } from '@myre/common-conf';
import {
  languages,
  mainLanguages,
  type Lang,
  type LangLocale,
  type Language,
} from '@myre/common-i18n';

export function getLanguagesForCurrentEnv(
  languagesRecord: Record<Lang, Language> = languages,
): Language[] {
  const languageValues = Object.values<Language>(languagesRecord);

  if (!isProduction()) {
    return languageValues;
  }

  return languageValues.filter(lang => lang.isInProduction);
}

export function getMainLanguagesForCurrentEnv(): Language[] {
  return getLanguagesForCurrentEnv(mainLanguages);
}

export function getLangForLangLocale(langLocale: LangLocale): Lang {
  return getLanguagesForCurrentEnv().find(
    language => language.langLocale === langLocale,
  ).lang;
}
